<template>
    <section class="body section-padding">
        <i class="fa-solid fa-quote-left"></i>
        <i class="fa-solid fa-quote-right"></i>
        <div class="box-card">
            <div class="title">
                <h2>L’histoire de EMCI</h2>
                <h2>racontée par <span class="span-background-blue">sa fondatrice</span></h2>
            </div>
            <div class="story-text mt-30">
                <p>
                    “Après des études en Psychologie du Travail et une première mission dans un cabinet RH à Bordeaux,
                    j’ai
                    rejoint la ville de Toulouse où j’ai créé en 1999, la société EMCI « Évaluation, Management,
                    Compétences
                    & Innovation ».
                </p>
                <p class="mt-20 mb-20">
                    EMCI est un cabinet de Conseil en Ressources Humaines et de Formations Professionnelles.
                </p>
                <p class="mt-20 mb-20">
                    J’ai débuté seule dans cette activité, pour ensuite recruter mes premiers collaborateurs au cours de
                    l’année 2003.
                    Pour définir les domaines d’expertise de EMCI, je dirais que le cabinet EMCI propose des prestations
                    de
                    conseil et d’accompagnement en ressources humaines : tels que le recrutement, la formation, la
                    gestion
                    de carrière, l’accompagnement des organisations et le conseil en stratégie RH.
                </p>
            </div>
            <div class="d-flex gap-3 mobile">
                <div class="story-text">
                    <p class="mt-20 mb-20">
                        Implanté à sa création à Toulouse, le cabinet EMCI a ensuite étendu ses activités aux régions
                        d'Occitanie et de Nouvelle-Aquitaine.
                    </p>
                    <p class="mt-20 mb-20">
                        En 2018, j’ai créé le <a href="https://www.rrh-groupe.fr" target="_blank"><b
                                class="bold-underline">groupe RRH</b></a>, regroupement de 7 cabinets implantés dans
                        diverses régions de
                        France.<br />
                        Ces partenariats confèrent à EMCI une présence à l'échelle nationale.
                    </p>
                    <p class="mt-20 mb-20">
                        Avec mes collaborateurs, nous créons des relations de qualité avec nos clients afin de
                        développer
                        des partenariats solides, et de travailler sur de nouveaux projets.
                    </p>
                    <p class="mt-70 mb-20">
                        <span class="bold">L'Humain notre Passion, votre Réussite !</span>
                    </p>
                </div>
                <div>
                    <div class="story-img mb-3">
                        <img src="/images/teams/story-img.jpg" alt="histoire">
                    </div>
                    <div class="founderName d-flex flex-column justify-content-center align-items-center">
                        <span>Emmanuelle MARKIEWICZ,</span>
                        <span>Fondatrice et Dirigeante</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
useHead({
    title: 'EMCI conseil en Ressources Humaines, Accompagnement Professionnel',
    meta: [
        {
            name: 'description',
            content: 'Cabinet de conseil en Ressources Humaines & Accompagnement Professionnel, créé en Occitanie en 1999. Notre équipe peut intervenir partout en France.'
        }
    ]
})
</script>
<style scoped>
.bold-underline {
    font-weight: bold;
    text-decoration: underline;
}

.body {
    overflow: hidden !important;
    margin-top: 120px;
    position: relative;
}

.section-padding {
    padding: 70px 290px;
}

.box-card {
    background: white;
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    gap: 1rem;
    padding: 60px;
    border-radius: 0.5625rem;
}

.title h2 {
    /* h2 */
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

.title h2:nth-child(1) {
    color: #318EC7;
}

.title h2:nth-child(2) {
    color: #25233E;
}

.story-text p {
    color: #25233E;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

.story-img img {
    vertical-align: middle;
    width: 720px;
    height: 400px;
    border-radius: 50%;
    object-fit: cover;
}

.founderName span {
    color: #318EC7;
    text-align: center;
    font-family: Nunito;
    font-size: 29px;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    /* 32.335px */
    letter-spacing: -0.435px;
}


.fa-quote-right,
.fa-quote-left {
    color: #83C1E8;
    font-size: 128px;
    position: absolute;
}

.fa-quote-left {
    top: 21%;
    left: 11%;
}

.fa-quote-right {
    bottom: 14%;
    right: 11%;
}

span[class='bold'] {
    font-weight: 600;
    font-size: 34px;
    font-family: 'Nunito';
}

/* Styles pour les écrans de petite taille (S) */
@media only screen and (max-width: 599px) {
    .section-padding {
        padding: 70px 10px;
    }

    .fa-quote-left {
        top: 10%;
        left: 9%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 28px;
    }

    .mobile {
        flex-direction: column-reverse;
    }

    .story-img img {
        height: 200px;
    }
}


/* Styles pour les écrans de taille moyenne (M) */
@media only screen and (min-width: 600px) and (max-width: 768px) {
    .section-padding[data-v-d01dfef2] {
        padding: 70px 10px;
    }

    .fa-quote-left {
        top: 17%;
        left: 2%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 71px;
    }

    .fa-quote-right {
        bottom: 8%;
        right: 3%;
    }

}

@media only screen and (min-width: 769px) and (max-width: 991px) {}

@media only screen and (min-width: 1000px) and (max-width: 1024px) {
    .section-padding[data-v-d01dfef2] {
        padding: 70px 80px;
    }

    .fa-quote-left {
        top: 17%;
        left: 2%;
    }

    .fa-quote-right,
    .fa-quote-left {
        font-size: 71px;
    }

    .fa-quote-right {
        bottom: 8%;
        right: 3%;
    }
}

@media only screen and (min-width: 1025px) and (max-width: 1087px) {}

@media only screen and (min-width: 1088px) and (max-width: 1872px) {}

@media only screen and (min-width: 1450px) and (max-width: 1800px) {}

/** ecran 1280 * 1024  */

@media screen and (min-width: 1088px) and (max-width: 1381px) {
    .section-padding {
        padding: 70px 229px;
    }

    .story-img img {
        width: 684px;
        height: 322px;
    }
}
</style>